export const removeEmpty = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== undefined && value !== null && value !== '',
    ),
  );
};

export const buildQueryParams = (params = {}, defaultLimit = 20) => {
  const result = { ...params };
  if (result.page && !result.limit) {
    result.limit = defaultLimit;
  }
  return removeEmpty(result);
};
